import { environmentHttpClient } from "client/Api/httpClient";

export const saveColumnsVisibility = (visibileColumnsIds: readonly number[]): Promise<void> => {
	return environmentHttpClient.put<void>(
		"Documents/SharePoint/ColumnsVisibility",
		{ visibileColumnsIds },
	);
};